<template>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="resignationDetailDialogVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        class="custom_form_dialog custom-form-dialog"
    >
        <template #title>
            <div class="avatar_name_wrap">
                <img
                    :src="
                        user_info.avatar ||
                        'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'
                    "
                    alt=""
                    class="header_img"
                />
                <div>
                    <p class="user_name">
                        {{ user_info.user_name }}
                        <span
                            :class="'tag-label-' + user_info.quit_status"
                            class="tag-label"
                            v-text="
                                user_info.quit_status == 0
                                    ? '待离职'
                                    : user_info.quit_status == 1
                                    ? '已离职'
                                    : user_info.quit_status == 2
                                    ? '已取消'
                                    : ''
                            "
                        >
                        </span>
                    </p>
                    <p>
                        <span>{{ user_info.department_path }}</span>
                    </p>
                </div>
            </div>
        </template>

        <div class="custom_form_body" v-loading="loading">
            <p class="dialog-txt-tip" v-if="user_info.quit_status == 0">该员工已办理离职，请确认工作交接无误后，操作确认离职</p>
            <el-form
                ref="formData"
                class="custom_form_detail_wrap"
                :rules="formRules"
                :model="formData"
                label-position="top"
            >
                <div class="form_module_title">离职信息</div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="离职日期" prop="quit_date">
                            <div
                                @click="handleClickFieldShow('quit_date')"
                                class="detail_value"
                                v-if="editField != 'quit_date'"
                                v-text="formData.quit_date"
                            ></div>
                            <el-date-picker
                                v-if="editField == 'quit_date'"
                                @blur="handleClickFieldHide('quit_date')"
                                format="yyyy-MM-dd"
                                placeholder="请选择离职日期"
                                type="date"
                                v-model="formData.quit_date"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="离职类型" prop="quit_type">
                            <div
                                @click="handleClickFieldShow('quit_type')"
                                class="detail_value"
                                v-if="editField != 'quit_type'"
                                v-text="
                                    dimission_type_list.find((find) => find.type_id == formData.quit_type)
                                        ? dimission_type_list.find((find) => find.type_id == formData.quit_type)
                                              .type_value
                                        : ''
                                "
                            ></div>
                            <el-select
                                v-else
                                placeholder="请选择离职类型"
                                v-model="formData.quit_type"
                                @change="handleClickFieldHide('quit_type')"
                            >
                                <el-option
                                    :label="item.type_value"
                                    :value="item.type_id"
                                    v-for="(item, index) in dimission_type_list"
                                    :key="index"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="离职原因" prop="quit_reason">
                            <div
                                @click="handleClickFieldShow('quit_reason')"
                                class="detail_value"
                                v-if="editField != 'quit_reason'"
                                v-text="formData.quit_reason"
                            ></div>
                            <el-select
                                v-else
                                placeholder="请选择离职原因"
                                v-model="formData.quit_reason"
                                @change="handleClickFieldHide('quit_reason')"
                            >
                                <el-option
                                    :label="item"
                                    :value="item"
                                    v-for="(item, index) in dimission_type_list.find(
                                        (find) => find.type_id == formData.quit_type
                                    )
                                        ? dimission_type_list.find((find) => find.type_id == formData.quit_type).reason
                                        : []"
                                    :key="index"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="离职备注" prop="quit_note" class="form-item-textarea">
                            <div
                                @click="handleClickFieldShow('quit_note')"
                                class="detail_value"
                                v-if="editField != 'quit_note'"
                                v-text="formData.quit_note"
                            ></div>

                            <el-input
                                v-else
                                @blur="handleClickFieldHide('quit_reason')"
                                :rows="3"
                                maxlength="200"
                                placeholder="请输入离职备注"
                                show-word-limit
                                type="textarea"
                                v-model="formData.quit_note"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <CustomFormDetailPc
                v-if="dataLoaded"
                ref="customFormPc"
                :field_list="formInfoList"
                :form_detail="formInfoData"
                :is_edit_mode="false"
                :is_detail_not_edit_mode="true"
                :pk_id="user_info.user_id"
            />
        </div>
        <span slot="footer" class="dialog-footer" v-if="user_info.quit_status == 0">
            <el-button @click.stop="handleDialogCancelQuit">取消离职</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirmQuit">确认离职</el-button>
        </span>
    </el-dialog>
</template>
<script>
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import { getFormFields, getUserDetail, getQuitReason, quitInfo, editQuitInfo, cancelQuit, confirmQuit } from "@/api";
export default {
    name: "resignation_detail",
    props: {
        resignationDetailDialogVisible: {
            type: Boolean,
            default: false,
        },
        user_info: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    components: { CustomFormDetailPc },
    data() {
        return {
            loading: false,
            dialogTitle: "离职详情",
            formData: {
                id: "",
                quit_date: "",
                quit_type: "",
                quit_reason: "",
                quit_note: "",
            },
            formRules: {
                quit_date: [{ required: true, message: "请选择离职日期" }],
                quit_type: [{ required: true, message: "请选择离职类型" }],
                quit_reason: [{ required: true, message: "请选择离职原因" }],
            },
            userList: [],
            formInfoData: {},
            formInfoList: [],
            dataLoaded: false,
            dimission_type_list: [],
            editField: "",
        };
    },
    computed: {},
    created() {
        this._getFromFields();
        if (this.user_info.id) {
            this.formData.id = this.user_info.id;
        }
        this.getQuitReason();
    },
    methods: {
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "users",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.formInfoList = res.data;
                        if (this.user_info.user_id) {
                            getUserDetail({
                                user_id: this.user_info.user_id,
                            }).then((res) => {
                                if (res.code === 200) {
                                    this.formInfoData = res.data;
                                    this.dataLoaded = true;
                                } else {
                                    this.$message.error(res.message);
                                }
                            });
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getQuitInfo() {
            this.loading = true;
            quitInfo({ id: this.formData.id }).then((res) => {
                if (res.code === 200) {
                    let { quit_date, quit_type, quit_reason, quit_note } = res.data;
                    this.formData.quit_date = quit_date;
                    this.formData.quit_type = String(quit_type);
                    this.formData.quit_reason = quit_reason;
                    this.formData.quit_note = quit_note;
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },
        getQuitReason() {
            getQuitReason({}).then((res) => {
                if (res.code === 200) {
                    this.dimission_type_list = res.data;
                    if (this.formData.id) {
                        this.getQuitInfo();
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleClickFieldShow(field) {
            if (this.user_info.quit_status == 2) return false;
            this.editField = field;
        },
        handleClickFieldHide(field) {
            if (field == "quit_type") {
                this.formData.quit_reason = "";
            }
            this.editField = "";

            this.handleDialogConfirm();
        },
        // 取消离职
        handleDialogCancelQuit() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    const h = this.$createElement;
                    this.$msgbox({
                        title: "取消离职",
                        message: h("div", null, [h("span", null, "取消离职后，该员工将恢复为正常在职状态。")]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: "prompt_message_custom",
                        confirmButtonText: "确定",
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass: "",
                        showClose: false,
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                done();
                            } else {
                                done();
                            }
                        },
                    })
                        .then(() => {
                            let postData = {
                                id: this.formData.id,
                            };
                            this.loading = true;
                            cancelQuit(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message({
                                        type: "success",
                                        message: res.message,
                                        duration: 1500,
                                        onClose: () => {
                                            this.$emit("update:resignationDetailDialogVisible", false);
                                            this.$emit("success");
                                        },
                                    });
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {});
                }
            });
        },
        // 确认离职
        handleDialogConfirmQuit() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    const h = this.$createElement;
                    this.$msgbox({
                        title: "确认离职",
                        message: h("div", null, [
                            h("span", null, "确认离职后，该员工的帐号将关闭，请确保工作交接已完成！！！"),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                        customClass: "prompt_message_custom",
                        confirmButtonText: "确定",
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass: "",
                        showClose: false,
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                done();
                            } else {
                                done();
                            }
                        },
                    })
                        .then(() => {
                            let postData = {
                                id: this.formData.id,
                            };
                            this.loading = true;
                            confirmQuit(postData).then((res) => {
                                if (res.code === 200) {
                                    this.$message({
                                        type: "success",
                                        message: res.message,
                                        duration: 1500,
                                        onClose: () => {
                                            this.$emit("update:resignationDetailDialogVisible", false);
                                            this.$emit("success");
                                        },
                                    });
                                }
                                this.loading = false;
                            });
                        })
                        .catch(() => {});
                }
            });
        },

        handleDialogClose() {
            this.$emit("update:resignationDetailDialogVisible", false);
        },
        handleDialogConfirm() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let postData = {
                        id: this.formData.id,
                        uid: this.user_info.user_id,
                        quit_date: this.formData.quit_date,
                        quit_type: this.formData.quit_type,
                        quit_reason: this.formData.quit_reason,
                        quit_note: this.formData.quit_note,
                    };
                    this.btnDisabled = true;
                    if (this.formData.id) {
                        editQuitInfo(postData).then((res) => {
                            if (res.code === 200) {
                                this.$message({
                                    type: "success",
                                    message: res.message,
                                    duration: 1500,
                                    onClose: () => {},
                                });
                            } else {
                                this.$message.error(res.message);
                            }
                            this.btnDisabled = false;
                        });
                    }
                }
            });
        },
    },
};
</script>
<style lang="scss">
.tag-label {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    margin-left: 8px;

    &.tag-label-0 {
        background-color: rgba(228, 65, 68, 0.1);
        color: rgba(228, 65, 68, 1);
    }

    &.tag-label-1 {
        background-color: rgba(90, 179, 51, 0.15);
        color: rgba(90, 179, 51, 1);
    }

    &.tag-label-2 {
        background-color: rgba(153, 153, 153, 0.15);
        color: rgba(153, 153, 153, 1);
    }
}
</style>
<style scoped lang="scss">
.detail_value {
    min-height: 32px;
}
</style>
